import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Default validation result used when the error is not chart of accounts
 * specific.
 */
export default class DefaultValidationResult extends AbstractChartOfAccountsValidationResult {
	isDefault() {
		return true;
	}

	static getType() {
		return undefined;
	}
}
